import {
  GetStatement_listStatements,
  GetStatement_listStatements_installmentsComing,
  GetStatement_listStatements_installmentsOpen,
  GetStatement_listStatements_installmentsOverdue,
  GetStatement_listStatements_installmentsPaid,
} from '../../services/types/GetStatement'
import { listUserSaleContracts_listUserSaleContracts } from '../../services/types/listUserSaleContracts'
import { ImageSourcePropType } from 'react-native'
import { getConstructionData_listUserSaleContracts } from '../../services/types/getConstructionData'
import { GetAvailableVisitationRaffles_listUserVisitEvents } from '../../services/types/getAvailableVisitationRaffles'
import { GetUserKeysDeliveryEventInvitations_listUserKeysDeliveryEventInvitations } from '../../services/types/GetUserKeysDeliveryEventInvitations'
import { DashboardCustomDropdownItem } from '../../screens/Dashboard/DashboardCustomDropdownList'
import { icons } from '../../constants/searchAssets'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { getFaqs_listFaqCategories } from '../../services/types/getFaqs'
import { User } from '../auth/authState'

const initialSelectedUserSaleContract: DashboardCustomDropdownItem = {
  id: 0,
  text: formatMessage(messages.enterpriseSelection_defaultMessage),
  icon: icons.home,
}

export const mainState = {
  availableVisitationEvents: undefined as GetAvailableVisitationRaffles_listUserVisitEvents[],
  changePasswordResponse: undefined as string,
  constructionData: undefined as getConstructionData_listUserSaleContracts[],
  currentConstructionImageUrl: undefined as ImageSourcePropType,
  currentCpfForPasswordRecovery: undefined as string,
  currentUserInfo: undefined as User,
  deleteOwnNotificationMessage: undefined as string,
  dropdownUserSaleContractsData: undefined as { id: number; text: string }[],
  faqs: undefined as getFaqs_listFaqCategories[],
  howManyNotifications: undefined as number,
  installmentsComing: undefined as GetStatement_listStatements_installmentsComing[],
  installmentsOpen: undefined as GetStatement_listStatements_installmentsOpen[],
  installmentsOverdue: undefined as GetStatement_listStatements_installmentsOverdue[],
  installmentsPaid: undefined as GetStatement_listStatements_installmentsPaid[],
  notificationsList: undefined,
  statement: undefined as GetStatement_listStatements,
  recoverPasswordResponse: undefined as string,
  passwordOnFirstLogin: undefined as string,
  requestPermissionToSendPush: undefined as boolean,
  pushToken: undefined,
  selectedUserSaleContract: initialSelectedUserSaleContract,
  shouldRefreshKeysDelivery: false,
  shouldRefreshRaffles: false,
  updateSendNotification: undefined as string,
  userKeysDeliveryEventInvitations: undefined as GetUserKeysDeliveryEventInvitations_listUserKeysDeliveryEventInvitations[],
  userSaleContracts: undefined as listUserSaleContracts_listUserSaleContracts[],
  duplicatesBankSlip: [] as GetStatement_listStatements_installmentsOverdue[],
  actualSaleContract: undefined as listUserSaleContracts_listUserSaleContracts,
  shouldRefreshNotifications: false,
}
